import { render, staticRenderFns } from "./ProfileIssues.vue?vue&type=template&id=cdcbd5c8"
import script from "./ProfileIssues.vue?vue&type=script&lang=js"
export * from "./ProfileIssues.vue?vue&type=script&lang=js"
import style0 from "./ProfileIssues.vue?vue&type=style&index=0&id=cdcbd5c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports